<template>
  <div id="header-container" class="header-container">
    <div
      id="header"
      class="app-header"
      :data-bs-theme="appOption.appHeaderInverse ? 'dark' : ''"
    >
      <!-- navbar-header -->
      <div class="navbar-header">
        <!-- header-nav -->
        <div class="navbar-nav">
          <!-- Botones para vista móvil -->
          <button
            type="button"
            class="navbar-mobile-toggler"
            v-if="appOption.appSidebarTwo"
            v-on:click="toggleAppSidebarEndMobileToggled"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>

          <!-- Botones para vista móvil -->
          <button
            type="button"
            class="navbar-mobile-toggler"
            v-if="
              appOption.appTopMenu &&
              !appOption.appSidebarHide &&
              !appOption.appSidebarTwo
            "
            v-on:click="toggleAppTopMenuMobileToggled"
          >
            <span class="fa-stack fa-lg">
              <i class="far fa-square fa-stack-2x"></i>
              <i class="fa fa-cog fa-stack-1x mt-1px"></i>
            </span>
          </button>
          <button
            type="button"
            class="navbar-mobile-toggler"
            v-if="
              appOption.appTopMenu &&
              appOption.appSidebarHide &&
              !appOption.appSidebarTwo
            "
            v-on:click="toggleAppTopMenuMobileToggled($event)"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <button
            type="button"
            class="navbar-mobile-toggler"
            v-if="!appOption.appSidebarHide"
            v-on:click="toggleAppSidebarMobileToggled"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>

        <div class="navbar-nav">
          <!-- Botón Volver -->
          <div v-if="appOption.appGoBack" class="navbar-item">
            <a
              href="javascript:;"
              @click="goBack()"
              class="navbar-link d-flex align-items-center"
              title="Volver"
            >
              <i class="fa fa-arrow-rotate-left me-1 text-theme"></i>
              <span class="d-lg-inline d-md-none">Volver</span>
            </a>
          </div>
        </div>

        <div v-if="!appOption.appGoBack" class="navbar-nav">
          <!-- Mega menú, si existe -->
          <div class="navbar-item dropdown">
            <button
              type="button"
              class="navbar-mobile-toggler"
              data-bs-toggle="collapse"
              data-bs-target="#top-navbar"
              v-if="appOption.appHeaderMegaMenu && !appOption.appSidebarTwo"
            >
              <span class="fa-stack fa-lg">
                <i class="far fa-square fa-stack-2x"></i>
                <i class="fa fa-cog fa-stack-1x mt-1px"></i>
              </span>
            </button>
          </div>
          <!-- componente con el contenido del mega menú, si existe -->
          <app-header-mega-menu
            v-if="appOption.appHeaderMegaMenu"
            @filters-updated="handleFiltersUpdate"
          />
        </div>

        <div v-if="!appOption.appGoBack" class="navbar-nav">
          <!-- Cuadro de búsqueda -->
          <div
            class="navbar-item navbar-form"
            v-if="appOption.appHeaderSearchToggled"
          >
            <form @submit.prevent="handleSearch">
              <div class="form-group">
                <input
                  ref="searchInput"
                  type="text"
                  class="form-control"
                  :placeholder="t('navBar.inputSearchPlaceholder')"
                />
                <button
                  type="submit"
                  class="btn btn-search"
                  :title="t('navBar.submit')"
                >
                  <i class="fa fa-search text-theme"></i>
                </button>
              </div>
            </form>
          </div>
          <!-- Instrucciones de la búsqueda -->
          <div
            v-if="appOption.appHeaderSearchToggled"
            class="navbar-item dropdown"
          >
            <a
              href="javascript:;"
              data-bs-toggle="dropdown"
              class="navbar-link dropdown-toggle"
              :title="t('navBar.notifications').toLocaleLowerCase()"
            >
              <i class="fa fa-question"></i>
              <span class="badge">{{ notificationData.length }}</span>
            </a>
            <div class="dropdown-menu media-list dropdown-menu-end">
              <div class="dropdown-header">
                {{ t("navBar.notifications") }} ({{ notificationData.length }})
              </div>
              <template v-if="notificationData && notificationData.length > 0">
                <a
                  href="javascript:;"
                  class="dropdown-item media"
                  v-for="(notification, index) in notificationData"
                  v-bind:key="index"
                >
                  <div class="media-left">
                    <i
                      v-if="notification.icon"
                      v-bind:class="notification.icon"
                    ></i>
                  </div>
                  <div class="media-body">
                    <h6 class="media-heading" v-html="notification.title"></h6>
                    <div class="text-muted fs-10px">
                      {{ notification.subTitle }}
                    </div>
                  </div>
                </a>
              </template>
              <template v-else>
                <div class="text-center w-300px py-3">
                  {{ t("navBar.noNotifications") }}
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!isPhoneViewport" class="navbar-nav">
        <!-- Titulo de la vista activa -->
        <h3>
          <i :class="appOption.appSelectedMenuIcon" class="text-theme"></i>
          <span class="d-lg-inline d-md-none m-2 title-theme">{{
            appOption.appSelectedMenu
          }}</span>
        </h3>
      </div>
      <div v-if="isPhoneViewport" class="d-flex">
        <!-- Titulo de la vista activa -->
        <div class="fs-16px ms-3 mt-3">
          <i :class="appOption.appSelectedMenuIcon" class="text-theme"></i>
          <span class="m-2">{{ appOption.appSelectedMenu }}</span>
        </div>
        <div class="navbar-nav">
          <div class="navbar-item navbar-user dropdown">
            <a
              href="javascript:void(0);"
              ref="dropdownButton"
              class="navbar-link d-flex align-items-center"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              role="button"
            >
              <img
                v-if="userPic !== undefined"
                :src="userPic"
                alt="userAvatar"
              />
              <span>
                <span class="d-md-inline">{{ userName }}</span>
                <b class="caret text-theme"></b>
              </span>
            </a>
            <div class="dropdown-menu dropdown-menu-end me-1">
              <!--<router-link to="/extra/profile" class="dropdown-item">{{
                t("navBar.editProfile")
              }}</router-link>
              <router-link
                to="/email/inbox"
                class="dropdown-item d-flex align-items-center"
              >
                {{ t("navBar.inbox") }}
                <span class="badge bg-danger rounded-pill ms-auto pb-4px"
                  >2</span
                >
              </router-link>
              <router-link to="/calendar" class="dropdown-item">{{
                t("navBar.calendar")
              }}</router-link>
              <router-link to="/extra/settings-page" class="dropdown-item">{{
                t("navBar.settings")
              }}</router-link>
              <div class="dropdown-divider"></div> -->
              <router-link @click="logOut" to="/" class="dropdown-item">
                <i class="fas fa-sign-out-alt me-2 text-theme"></i> Cerrar
                sesión
              </router-link>

              <div class="dropdown-divider"></div>

              <a href="#" class="dropdown-item" @click.prevent="openAbout">
                <i class="fas fa-info-circle me-2 text-theme"></i> Acerca de /
                versión
              </a>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!isPhoneViewport" class="navbar-nav">
        <!-- Avatar, nomvbre de usuario y dropdown con menú de opciones -->
        <div>
          <div class="navbar-item navbar-user dropdown">
            <a
              href="javascript:void(0);"
              ref="dropdownButton"
              class="navbar-link d-flex align-items-center"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              role="button"
            >
              <img
                v-if="userPic !== undefined"
                :src="userPic"
                alt="userAvatar"
              />
              <span>
                <span class="d-none d-md-inline">{{ userName }}</span>
                <b class="caret text-theme"></b>
              </span>
            </a>
            <div class="dropdown-menu dropdown-menu-end me-1">
              <!-- <router-link to="/extra/profile" class="dropdown-item">{{
                t("navBar.editProfile")
              }}</router-link>
              <router-link
                to="/email/inbox"
                class="dropdown-item d-flex align-items-center"
              >
                {{ t("navBar.inbox") }}
                <span class="badge bg-danger rounded-pill ms-auto pb-4px"
                  >2</span
                >
              </router-link>
              <router-link to="/calendar" class="dropdown-item">{{
                t("navBar.calendar")
              }}</router-link>
              <router-link to="/extra/settings-page" class="dropdown-item">{{
                t("navBar.settings")
              }}</router-link>
              <div class="dropdown-divider"></div> -->
              <router-link @click="logOut" to="/" class="dropdown-item">
                <i class="fas fa-sign-out-alt me-2 text-theme"></i> Cerrar
                sesión
              </router-link>

              <div class="dropdown-divider"></div>

              <a href="#" class="dropdown-item" @click.prevent="openAbout">
                <i class="fas fa-info-circle me-2 text-theme"></i> Acerca de /
                versión
              </a>
            </div>
          </div>
        </div>

        <!-- Botón de apertura / cierre de la segunda sidebar, si existe -->
        <div
          class="navbar-divider d-none d-md-block"
          v-if="appOption.appSidebarTwo"
        ></div>
        <div
          class="navbar-item d-none d-md-block"
          v-if="appOption.appSidebarTwo"
        >
          <a
            href="javascript:;"
            v-on:click="toggleAppSidebarEndToggled"
            class="navbar-link icon"
          >
            <i class="fa fa-th" title="Abrir barra de estadísticas"></i>
          </a>
        </div>
      </div>
      <!-- / header-nav -->
    </div>
  </div>
</template>

<script setup lang="ts">
// métodos
import { ref, computed, onMounted, onBeforeUnmount, watch } from "vue";
// navegación
import { RouterLink } from "vue-router";
import { useRouter } from "vue-router";
// tipos
import type { Ref } from "vue";
// composables
import { slideToggle } from "@/composables/slideToggle";
// componentes
import AppHeaderMegaMenu from "@/components/app/HeaderMegaMenu.vue";
// iconos de banderas
import "flag-icons/css/flag-icons.min.css";
// i18n
import { useI18n } from "vue-i18n";
// stores
import { useAppOptionStore } from "@/stores/app-option";
import { useAuthStore } from "@/stores/auth";
import { useAppSidebarMenuStore } from "@/stores/app-sidebar-menu";
import { useSearchStore } from "@/stores/searchStore";
import { useBudgetsStore } from "@/stores/budgetsStore";
import Dropdown from "bootstrap/js/dist/dropdown";
// instancias
const { t } = useI18n();
const appOption = useAppOptionStore();
const authStore = useAuthStore();
const searchStore = useSearchStore();
const budgetsStore = useBudgetsStore();
const appSidebarMenuStore = useAppSidebarMenuStore();
const router = useRouter();
// estado para saber si el header está visible, por defecto si lo esta
const isHeaderVisible = ref(true);

// ============================================================================
// 📁 Responsive y comprobación del dispositivo del usuario
// ============================================================================

const windowWidth = ref(window.innerWidth);

const updateWindowWidth = (): void => {
  windowWidth.value = window.innerWidth;
};

/**
 * 📱 Teléfono real
 */
const isPhoneViewport = computed(() => {
  return windowWidth.value < 768;
});

/**
 * 📲 Tablet
 */
const isTabletViewport = computed(() => {
  return windowWidth.value >= 768 && windowWidth.value <= 1366;
});

/**
 * 🖥️ Desktop / tablet grande
 */
const isDesktopViewport = computed(() => {
  return windowWidth.value > 1366;
});

/**
 * 📱 Detección legacy basada en UA
 * 💡 Mantener por compatibilidad con otras apps
 */
const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent);

const dropdownButton = ref<HTMLElement | null>(null);
// nombre de usuario
const userName: Ref<string | null> = ref("");
const userPic: Ref<string | undefined> = ref("");
// v-model del input de búsqueda
const searchInput = ref<string>("");
// ejemplo de objeto con las notificaciones
const notificationData = [
  {
    icon: "media-object bg-gray-500",
    title: "Se traen todos los presupuestos",
    subTitle: "Ejemplo: click en 🔍",
  },
  {
    icon: "fa fa-circle-dot media-object bg-gray-500",
    title: "Se busca el presupuesto por el número<br /> que sigue al punto",
    subTitle: "Ejemplo: escribir .784 y click en 🔍",
  },
  {
    icon: "fa fa-slash media-object bg-gray-500",
    title: "Se busca el presupuesto por la fecha<br /> que sigue a la barra",
    subTitle: "Ejemplo: escribir /23-10-2023 y click en 🔍",
  },
  {
    icon: "fa fa-quote-left media-object bg-gray-500",
    title:
      "Se busca por Nombre Fiscal, Nombre<br /> Comercial de Cliente y Dirección<br /> del Cliente, según el valor introducido",
    subTitle: 'Ejemplo: escribir "Numbre_del_Cliente" y click en 🔍',
  },
];
// volver
const goBack = () => {
  if (appOption.appSelectedMenu == "Presupuestos") {
    // se vuelva a la vista principal de presupuestos
    budgetsStore.changeFlag();
  } else if (appOption.appSelectedMenu == "Pedidos") {
    appOption.appSelectedMenu = "Inicio";
    router.push("/inicio");
  }
};
// logout
const logOut = async () => {
  await authStore.logOut();
  await router.replace({ name: "login" });
};

// Apertura de ion-chip "acerca de / versión"
function openAbout() {
  window.dispatchEvent(new CustomEvent("pwa:open-sheet"));
}

function toggleAppSidebarMobileToggled() {
  appOption.appSidebarMobileToggled = !appOption.appSidebarMobileToggled;
}

function toggleAppSidebarEndToggled() {
  appOption.appSidebarEndToggled = !appOption.appSidebarEndToggled;
}

function toggleAppSidebarEndMobileToggled() {
  appOption.appSidebarEndMobileToggled = !appOption.appSidebarEndMobileToggled;
}

function toggleAppHeaderSearch(event: any) {
  event.preventDefault();

  appOption.appHeaderSearchToggled = !appOption.appHeaderSearchToggled;
}

function toggleAppTopMenuMobileToggled(event?: MouseEvent) {
  const el = document.querySelector(".app-top-menu") as HTMLElement | null;
  if (!el) return; // ⬅️ narrow de tipo
  slideToggle(el, 300); // ya es HTMLElement
}

function handleWindowResize() {
  window.addEventListener("resize", function () {
    var elm = document.querySelector(".app-top-menu");
    if (elm) {
      elm.removeAttribute("style");
    }
  });
}
// se escuchan los cambios en los formularios de los filtros
const handleFiltersUpdate = (data: any) => {
  console.log("Datos combinados:", data);
  // Aquí puedes hacer lo que necesites con el objeto combinado
};
// función que envia los datos de búsqueda rápida y fgiltros y pide la info de la vista
const handleSearch = async () => {
  const token = await authStore.getJwt;
  const budgetParams = {
    valorBusqueda: "%",
    fechaDesde: null,
    fechaHasta: null,
    idCliente: 0,
    idLocalCliente: 0,
    idDireccionEnvio: 0,
    idVendedor: 0,
    pendientes: "TcTodo",
  };
  if (searchInput.value) {
    await searchStore.search(budgetParams, token);
  }
};
// se muestra el header cuando appOption.appHeaderHover es false
const showHeader = () => {
  const header = document.getElementById("header");
  if (header) {
    header.classList.remove("hidden");
  }
  isHeaderVisible.value = true;
};
// se oculta el header cuando appOption.appHeaderHover es true
const hideHeader = () => {
  const header = document.getElementById("header");
  if (header) {
    header.classList.add("hidden");
  }
  isHeaderVisible.value = false;
};
// función para inicializar los eventos de hover
const initHoverEvents = () => {
  const headerContainer = document.getElementById("header-container");
  if (headerContainer) {
    headerContainer.addEventListener("mouseenter", showHeader);
    headerContainer.addEventListener("mouseleave", hideHeader);
  }
};
// función para remover los eventos de hover
const removeHoverEvents = () => {
  const headerContainer = document.getElementById("header-container");
  if (headerContainer) {
    headerContainer.removeEventListener("mouseenter", showHeader);
    headerContainer.removeEventListener("mouseleave", hideHeader);
  }
};
// observa el cambio de appOption.appHeaderHover
watch(
  () => appOption.appHeaderHover,
  (newVal) => {
    // si es true se oculta el header
    if (newVal == true) {
      hideHeader();
      initHoverEvents();
      // si es false se muestra
    } else {
      showHeader();
      removeHoverEvents();
    }
  },
  { immediate: true },
);

onMounted(() => {
  // si appOption.appHeaderHover es true se oculta el header, si es false se muestra
  if (appOption.appHeaderHover) {
    hideHeader();
    initHoverEvents();
  } else {
    showHeader();
  }
  handleWindowResize();
  userPic.value = authStore.getUserPic
    ? `data:image/png;base64,` + authStore.getUserPic
    : undefined;
  userName.value = authStore.getUserShortName;
  document.querySelectorAll(".dropdown-toggle").forEach((dropdown) => {
    new Dropdown(dropdown); // Crea una instancia para cada dropdown
  });
});
// se eliminan los efectos de hover antes de salir
onBeforeUnmount(() => {
  removeHoverEvents();
});
</script>
<style scpoed>
.navbar-brand {
  font-size: 13px !important;
  font-weight: bold !important;
}

.title-theme {
  color: var(--bs-body-color);
}

@media (max-width: 767.98px) {
  .app-header-fixed {
    padding-top: 50px !important;
  }
}
</style>
